// extracted by mini-css-extract-plugin
export default {"carouselContainer":"JCarousel_carouselContainer__GTHlx","carouselTrack":"JCarousel_carouselTrack__nXqRI","scroll":"JCarousel_scroll__nnf7c","card":"JCarousel_card__KjCb9"};